import { render, staticRenderFns } from "./Template225.vue?vue&type=template&id=2b99d88a"
import script from "./Template225.vue?vue&type=script&lang=js"
export * from "./Template225.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b99d88a')) {
      api.createRecord('2b99d88a', component.options)
    } else {
      api.reload('2b99d88a', component.options)
    }
    module.hot.accept("./Template225.vue?vue&type=template&id=2b99d88a", function () {
      api.rerender('2b99d88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Template225.vue"
export default component.exports